import type { Action, GenericActionKey, PageActionMap, Permission } from '~/api/interface';
import { PageKey } from '~/constants/page';

type ArrayType<T> = T extends (infer U)[] ? U : never;

export const usePermissionData = () =>
  useState<Permission | undefined>('permissionData', undefined);

export function usePageAndActionPermissionData() {
  const permissionData = usePermissionData();
  return {
    hasActionPermission(key: GenericActionKey | ArrayType<PageActionMap[keyof PageActionMap]>) {
      if (!permissionData.value) {
        return true;
      }

      let pageActions: Action | undefined;

      permissionData.value.pages?.find(page => {
        const action = page.actions?.find(action => action.key === key);
        if (action) {
          pageActions = action;
          return true;
        }
        return false;
      });

      pageActions =
        pageActions ||
        (permissionData.value.genericActions?.find(action => action.key === key) as Action);

      if (pageActions) {
        return !!pageActions.hasPermission;
      }

      return false;
    },
    hasPagePermission(pageName: PageKey) {
      if (pageName === PageKey.NOT_FOUND) {
        return true;
      }

      if (pageName === PageKey.NO_PERMISSION) {
        return true;
      }

      const pagePermission = permissionData.value?.pages?.find(page => page.key === pageName);

      if (!pagePermission) {
        // 找不到权限配置信息的时候，则认为有权限
        return true;
      }

      return !!pagePermission.hasPermission;
    },
  };
}
